<template>
    <cadastro-simples-form
        endpoint="tipo-ocorrencia"
        rota-base="/admin/tipo-ocorrencia"
        titulo-singular="Tipo de Ocorrência"
        :campos-extras='[
            { campo: "descricao", label: "Descrição", tipo: "text" }
        ]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
